export const initBookACallBtn = () => {
	const bookACallBtn = document.querySelector('.btn--book-a-call')
	const contactSection = document.querySelector('.contact-section')
	const contactForm = document.querySelector('.contact')

	if (!bookACallBtn || !contactSection || !contactForm) {
		return
	}

	const observer = new IntersectionObserver(
		(entries) => {
			if (entries[0].isIntersecting) {
				contactForm.classList.add('active')
			}
		},
		{root: null, rootMargin: '0px', threshold: 1.0}
	)

	observer.observe(contactSection)

	bookACallBtn.addEventListener('click', () => {
		contactForm.classList.remove('active')
		contactSection.scrollIntoView({behavior: 'smooth', block: 'center'})
	})
}
